<template>
  <Bubble
    :options="computedChartOptions"
    :data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :width="width"
    :height="height"
    data-test-name="bubble-chart"
    data-test-variant=""
    data-test-state=""
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { Bubble } from 'vue-chartjs'

import * as ChartJS from 'chart.js'
import { cloneDeep, merge } from 'lodash-unified'
import { getChartDefaultOptions } from './utils'
import type { PropType } from 'vue'
import type { BubbleDataPoint, ChartData, ChartOptions, Plugin } from 'chart.js'

const { Chart, Legend, LinearScale, PointElement, Title, Tooltip } = ChartJS
Chart.register(Title, Tooltip, Legend, PointElement, LinearScale)

defineOptions({ name: 'BBubbleChart' })

const props = defineProps({
  chartId: {
    type: String,
    default: 'bubble-chart',
  },
  datasetIdKey: {
    type: String,
    default: 'label',
  },
  width: {
    type: Number,
    default: 480,
  },
  height: {
    type: Number,
    default: 240,
  },
  plugins: {
    type: Array as PropType<Plugin<'bubble'>[]>,
    default: () => [],
  },
  chartData: {
    type: Object as PropType<ChartData<'bubble', BubbleDataPoint[], unknown>>,
    default: () => ({ datasets: [] }),
  },
  chartOptions: {
    type: Object as PropType<ChartOptions<'bubble'>>,
    default: () => ({ responsive: true, maintainAspectRatio: true }),
  },
})

const defaultOptions = cloneDeep(
  getChartDefaultOptions('bubble')
) as ChartOptions<'bubble'>

const computedChartOptions = computed(() =>
  merge(defaultOptions, props.chartOptions)
)
</script>
